export class LoginInformations {
  Email: string = '';
  Password: string = '';
  AlertSuscriberIds: string = '';
}
